
import { formatCurrency, formatNumbersByLang } from '@/utils/numberFormats';
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';

interface ChannelPlanProps {
  price: number;
  sms: number;
  whatsapp: number;
  whatsappUser: number;
  email: number;
  smsUnitPrice: number;
  whatsappBusinessUnitPrice: number;
  whatsappUserUnitPrice: number;
  emailUnitPrice: number;
  id: string;
}

@Component
export default class ChannelPlanDetails extends Vue {
  @Prop({
    required: true,
    default: () => ({}),
    type: Object,
  }) private channelPlanProps!: ChannelPlanProps

  @Prop({
    required: true,
    default: () => '',
    type: String,
  }) private currency!: string;

  formatCurrency = formatCurrency;

  formatNumbersByLang = formatNumbersByLang;

  private isAccordionActive = false;

  private isReady = false;

  updated() {
    this.$nextTick(() => {
      if (!this.isReady) {
        this.isReady = true;
      }
    });
  }

  get accordionElement() {
    return this.$el.querySelector('.accordion');
  }

  toggleAccordion() {
    this.isAccordionActive = !this.isAccordionActive;
  }

  // esse comportamento está sendo analisado por PD
  // scrollIntoView() {
  //   setTimeout(() => {
  //     this.accordionElement!.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }, 500);
  // }

  @Watch('channelPlanProps', { deep: true })
  onChannelPlanPropsChange(newValue: ChannelPlanProps, oldValue: ChannelPlanProps) {
    if (!this.isReady) return;

    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
      this.isAccordionActive = true;
      // this.scrollIntoView();
    }
  }
}
